import React, { useEffect, useState } from "react";
import { Menu, MenuItem, Button, Box, TextField, Select, OutlinedInput, CardMedia } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";

interface HorizontalMenuProps {
  onModelSelect: (model: string) => void;
  model: string;
}

const HorizontalMenu: React.FC<HorizontalMenuProps> = ({ onModelSelect, model }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedModel, setSelectedModel] = useState<string>(model ?? "ball");
  const open = Boolean(anchorEl);

  useEffect(() => {
    setSelectedModel(model);
  }, [model]);

  const handleSelectType = (model: string) => {
    setSelectedModel(model);
    onModelSelect(model);
    setAnchorEl(null);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const textMenuItem = (text: string) => {
    switch(text) {
      case "ball":
        return "Default";
      case "trisign":
        return "Tri-Sign";
      case "planet":
        return "Planet";
      case "ballnoball":
        return "Banner";
    }
  };

  return (
    <Box sx={{ padding: 2, display: "flex", flex: 1 }}>
      <Button
        endIcon={open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
        aria-controls={open ? "horizontal-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        fullWidth
        sx={{ 
          color: "black", 
          fontWeight: 400,
          fontSize: 16, 
          border:  "1px solid", 
          borderColor: "rgba(0, 0, 0, 0.23)",
          height: "55px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <Box sx={{ ml: 1 }}>
        {selectedModel && (textMenuItem(selectedModel))}
        </Box>
      </Button>
      <Menu
        id="horizontal-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          sx: {
            display: "flex", // Makes the menu items horizontal
            flexDirection: "row",
            padding: 0,
            justifyContent: "center",
          },
        }}
        PaperProps={{
          sx: {
            display: "flex",
            flexDirection: "row",
            borderRadius: 2,
          },
        }}
      >
        <MenuItem onClick={() => handleSelectType("ball")}>
          <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/default.png"}
              alt={"default"}
            />
            Default
          </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("trisign")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/trisign.png"}
              alt={"trisign"}
            />
          Tri-Sign
        </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("ballnoball")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/default.png"}
              alt={"banner"}
            />
          Banner
        </Box>
        </MenuItem>
        <MenuItem onClick={() => handleSelectType("planet")}>
        <Box sx={{ textAlign: "center", fontSize: 12, fontWeight: 600 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/planet.png"}
              alt={"planet"}
            />
          Planet
        </Box>
        </MenuItem>
        {/* <MenuItem onClick={() => handleSelectType("billboard")}>
        <Box sx={{ textAlign: "center", fontSize: 10 }}>
            <CardMedia
              sx={{ display: "flex", justifyContent: "end", width: "80px", height: "80px" }}
              component="img" 
              src={"/images/beaconpreview/billboard.png"}
              alt={"billboard"}
            />
          Billboard
        </Box>
        </MenuItem> */}
      </Menu>
    </Box>
  );
};

export default HorizontalMenu;
